// utils/fetchWithAuth.js
export async function fetchWithAuth(url, options = {}) {
  const token = localStorage.getItem("authToken");
  if (!token) throw new Error("Token manquant. Veuillez vous reconnecter.");

  const res = await fetch(url, {
    ...options,
    headers: {
      Authorization: `Bearer ${token}`,
      ...options.headers,
    },
  });

  if (res.status === 401) {
    // ✅ Don't clear token or redirect here (prevents loops)
    throw new Error("Session expirée (401).");
  }

  return res;
}